const EmptyComponent = () => {
  // Render empty component to prevent rendering of default Chat components
  return null
}

export default EmptyComponent
